import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import VueGtag from 'vue-gtag'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import store from './store/store.js'
import axios from 'axios'

import sidebarLinks from './sidebarLinks'
import managementSidebarLinks from './managementSidebarLinks'
import moment from 'moment'

const axiosPlugin = {
  install: (Vue) => {
      // Set config defaults when creating the instance
    const http = axios.create()
    http.defaults.withCredentials = true
    http.defaults.baseURL = location.protocol + '//' + location.hostname + '/api'
    http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    Vue.prototype.$http = http
  }
}

const momentPlugin = {
  install: (Vue) => {
    Vue.prototype.moment = moment
  }
}

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify, {type: 'success', horizontalAlign: 'right', verticalAlign: 'bottom'})
Vue.use(axiosPlugin)
Vue.use(SideBar, {sidebarLinks: sidebarLinks, managementSidebarLinks: managementSidebarLinks})
Vue.use(VeeValidate)
Vue.use(momentPlugin)
locale.use(lang)

const getEnvironmentBanner = {
  install (Vue, options) {
    Vue.prototype.getEnvironment = () => {
      var matches = Vue.prototype.$http.defaults.baseURL.match(/\/api-(.*)$/)
      var part = matches !== null && matches.length === 2 ? matches[1] : null
      var env
      if (part === 'dev') {
        env = 'development'
      } else if (part === 'staging') {
        env = 'staging'
      } else {
        env = 'production'
      }
      return env
    }
    Vue.prototype.getEnvironmentText = () => {
      var env = Vue.prototype.getEnvironment()
      return env.charAt(0).toUpperCase() + env.substr(1)
    }
  }
}
Vue.use(getEnvironmentBanner)
// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to, from) => {
  if (document.getElementsByClassName('main-panel').length > 0) {
    document.getElementsByClassName('main-panel')[0].scrollTop = 0
  }
})

Vue.use(VueGtag, {
  // config: { id: 'G-M4FR2CEQ2J' }
  config: { id: 'G-G1XQQHD09S' }
}, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js